import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiGetRequest } from '../../model/api/api-request/api-get-request';
import { ApiPostRequest } from '../../model/api/api-request/api-post-request';
import { ApiPutRequest } from '../../model/api/api-request/api-put-request';
import { ApiDeleteRequest } from '../../model/api/api-request/api-delete-request';

@Injectable()
export class ApiClient
{
    private readonly httpClient: HttpClient;

    public constructor(httpClient: HttpClient)
    {
        this.httpClient = httpClient;
    }

    public get<T>(request: ApiGetRequest): Observable<T>
    {
        return this.httpClient.get(request.Uri) as Observable<T>;
    }

    public post<T>(request: ApiPostRequest): Observable<T>
    {
        return this.httpClient.post(request.Uri, request.Payload) as Observable<T>;
    }

    public put<T>(request: ApiPutRequest): Observable<T>
    {
        return this.httpClient.put(request.Uri, request.Payload) as Observable<T>;
    }

    public delete<T>(request: ApiDeleteRequest): Observable<T>
    {
        return this.httpClient.delete(request.Uri) as Observable<T>;
    }
}

export interface ILotteryParameters
{
    lotteryId: number;
}
